import Tabby from 'tabbyjs';
import MatchHeight from '../helpers/element/matchHeight';

class Tabs {
  constructor(container) {
    this.container = container;
    this.tabs = null;
    this.tabsParent = null;
    this.tabsContent = [];
    this.selector = '[data-tabs]';

    this.getTabElements();

    if (this.elems.length > 0) {
      this.setTabIDs();
      this.initTabs();
      this.initTabsNav();
      this.getTabHeights();
      this.setEvents();
    }
  }

  getTabElements() {
    this.elems = this.container.querySelectorAll(this.selector);
    this.tabsParent = this.container.querySelector('.tabs-body');
    this.tabsContent = this.container.querySelectorAll('.tabs-item');
    this.tabNav = this.container.querySelectorAll('.tabs-nav');
  }

  setTabIDs() {
    this.elems.forEach((elem, i) => {
      elem.setAttribute('data-tabs', i);
    });
  }

  initTabs() {
    this.elems.forEach((elem, i) => {
      this.tabs = new Tabby(`[data-tabs="${i}"]`);
      elem.tabs = this.tabs; // eslint-disable-line no-param-reassign
      this.handleInital(elem);
    });
  }

  initTabsNav() {
    if (this.tabNav.length > 0 && this.tabs !== null) {
      this.tabNav.forEach((elem) => {
        elem.addEventListener('click', () => {
          this.tabs.toggle(elem.dataset.target);
        });
      });
    }
  }

  getTabHeights() {
    this.containerHeight = 0;
    this.tabsContent.forEach((elem) => {
      elem.style.display = 'block'; // eslint-disable-line no-param-reassign
      const height = elem.clientHeight;
      elem.removeAttribute('style');
      elem.style.setProperty('--tab-height', `${height}px`);

      if (height > this.containerHeight) {
        this.containerHeight = height;
      }
    });

    this.tabsParent.style.setProperty('--tabs-max-height', `${this.containerHeight}px`);
  }

  setEvents() {
    return this;
    // document.addEventListener('tabby', (e) => {
    //   const tab = e.target;
    //   const { content } = e.detail;

    //   // this.constructor.matchHeight(content);
    //   // this.constructor.toggleSlideTab(tab);
    // }, false);
  }

  handleInital(elem) {
    const activeElem = elem.querySelector('[aria-selected=true]');

    if (activeElem.hash !== null) {
      const activeContent = document.querySelector(activeElem.hash);
      this.constructor.matchHeight(activeContent);
    }
  }

  static toggleSlideTab(tab) {
    const tabs = document.querySelectorAll('.tabs-nav--slide');
    let target = tab.href.replace(`${window.location.origin}${window.location.pathname}`, '');
    target = target.substring(1);

    if (tabs.length > 0) {
      tabs.forEach((tabItem) => {
        const currentTarget = tabItem.dataset.target;
        const classListMethod = target === currentTarget ? 'add' : 'remove';
        tabItem.classList[classListMethod]('is-selected');
      });
    }
  }

  static matchHeight(container) {
    const elems = container.querySelectorAll('[data-match-height]');
    if (elems.length > 0) {
      new MatchHeight(elems); // eslint-disable-line no-new
    }
  }
}

// barba.hooks.beforeEnter(({ next }) => {
//  new Tabs(next.container);
// });

export function initTabs() {
  const elems = document.querySelectorAll('[data-tabs]');
  if (elems.length > 0) {
    new Tabs(document); // eslint-disable-line no-new
  }
}
